export const typeChart = {
  areaChart: 1,
};
export const topRate = {
  top1: {
    colorOvalLeft: '#e8ac44',
    colorOvalRight: '#fdefae',
    colorBottom: '#eb505a',
    colorBorder: '#f1c56a',
  },
  top2: {
    colorOvalLeft: '#7cc1d2',
    colorOvalRight: '#e5fafe',
    colorBottom: '#eb505a',
    colorBorder: '#bee2e9',
  },
  top3: {
    colorOvalLeft: '#ff5f39',
    colorOvalRight: '#ffd0c3',
    colorBottom: '#eb505a',
    colorBorder: '#fb9c72',
  },
};
export const DEFAULT_CODE = 'AAA';
export const DEFAULT_CODE_NAME = 'An Phat Bioplastics';
export const DEFAULT_EXCHANGE = 'HOSE';

export default {
  INDUSTRY: 'allIndustries',
  GROUP: 'group',
};
